import { useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'

// Identificador do build, definido no workflow de deploy (que também publica o
// /version.json com o mesmo valor). Sem ele (build local), a verificação fica desligada.
const BUILD_ID = process.env.REACT_APP_BUILD_ID
// Evita checar a cada troca de rota rápida
const INTERVALO_MINIMO_MS = 60 * 1000
// Guarda para qual build já tentamos recarregar, evitando loop caso algum cache
// intermediário ainda entregue o HTML antigo depois do reload
const STORAGE_KEY = 'vexado:reload-build-id'

async function buscarBuildIdPublicado () {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return null
    const data = await response.json()
    return typeof (data && data.buildId) === 'string' ? data.buildId : null
  } catch (e) {
    return null
  }
}

function jaTentouRecarregarPara (buildId) {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === buildId
  } catch (e) {
    return false
  }
}

function marcarTentativaDeReload (buildId) {
  try {
    sessionStorage.setItem(STORAGE_KEY, buildId)
  } catch (e) {
    // sessionStorage indisponível: segue sem a proteção contra loop
  }
}

/**
 * Detecta quando uma versão nova do web foi publicada e recarrega a página.
 * Checa ao voltar para a aba/app (visibilitychange) e ao trocar de rota — momentos
 * em que recarregar não descarta nada que o usuário esteja preenchendo. Resolve o
 * app (WebView) que fica aberto em background por dias sem pegar o deploy novo.
 */
const VerificadorVersao = ({ location }) => {
  const ultimaChecagemRef = useRef(0)

  useEffect(() => {
    if (!BUILD_ID || process.env.NODE_ENV !== 'production') return undefined

    const verificar = async () => {
      const agora = Date.now()
      if (agora - ultimaChecagemRef.current < INTERVALO_MINIMO_MS) return
      ultimaChecagemRef.current = agora

      const publicado = await buscarBuildIdPublicado()
      if (!publicado || publicado === BUILD_ID || jaTentouRecarregarPara(publicado)) return

      marcarTentativaDeReload(publicado)
      window.location.reload()
    }

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') verificar()
    }

    verificar()
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => document.removeEventListener('visibilitychange', onVisibilityChange)
  }, [location.pathname])

  return null
}

export default withRouter(VerificadorVersao)
